import axios from 'axios';

const http = axios.create({
  baseURL: 'https://loginv2.timkj.cn/',
});

// 设置请求拦截器
http.interceptors.request.use(
  (req) => {
    req.headers['Content-Type'] = 'application/json; charset=UTF-8';
    return req;
  },
  (error) => {
    return error;
  }
);

// 设置响应拦截器
http.interceptors.response.use(
  (res) => {

    return res;
  },
  (error) => {
    return error;
  }
);

export default http;
